module.exports = __webpack_public_path__ + "files/cce15e87cb744db056329d5a9b2695a8.png";